import { ShieldAirplaneIcon } from './ShieldAirplaneIcon';

/**
 * author: GreenTurtwig
 * id B8FB8784-2E21-4D35-9DE8-95E8E2A42591
 * name shield-airplane
 * version: 1.7.22
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-airplane.svg
 * tags
 * - Transportation + Flying 
 */
export const PlaneShieldIcon = ShieldAirplaneIcon;
export default PlaneShieldIcon